import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver errors (common in React with Radix UI on mobile)
// This is a known issue and these errors are harmless but create bad UX
const resizeObserverErrorHandler = (e) => {
  const errorMessage = e.message || '';
  const errorReason = e.reason?.message || '';
  
  if (
    errorMessage.includes('ResizeObserver loop') ||
    errorMessage.includes('ResizeObserver loop completed with undelivered notifications') ||
    errorMessage.includes('ResizeObserver loop limit exceeded') ||
    errorReason.includes('ResizeObserver loop')
  ) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
};

// Handle both error and unhandledrejection events
window.addEventListener('error', resizeObserverErrorHandler);
window.addEventListener('unhandledrejection', resizeObserverErrorHandler);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
